export const darkTheme = {
  menu: {
    primaryTextColor: "rgba(255, 255, 255, 1)",
    secondaryTextColor: "rgba(150, 156, 161, 1)",
    background: "rgba(29, 28, 33, 1)",
    groupContentBackground: "rgba(38, 36, 43, 1)",
    deleteColor: "rgba(238, 80, 80, 1)",
    version: "rgba(150, 156, 161, 0.8)",
    infoText: "rgba(135, 140, 145, 1)",
    selectedTextColor: "rgba(146, 139, 237, 1)",
    selectedOpionBackground: "rgba(31, 36, 48, 1)",
    loadingIndicator: "rgba(146, 139, 237, 1)",
    enterPhoneNumberBackground: "rgba(48, 50, 58, 1)",
    avatarBackground: "rgba(75, 81, 95, 1)",
    toggleFadedColor: "rgba(150, 156, 161, 0.5)",
  },
  chat: {
    selectedBackground: "rgba(41, 40, 66, 1)",
    elementSecondaryColor: "rgba(150, 156, 161, 1)",
    receivedMessageBackground: "rgba(28, 32, 35, 1)",
    sentMessageBackground: "rgba(61, 58, 99, 1)",
    sentMessageTextColor: "rgba(250, 250, 250, 1)",
    receivedMessageTextColor: "rgba(255, 255, 255, 1)",
    sentTime: "rgba(150, 156, 161, 0.7)",
    readIconColor: "rgba(146, 139, 237, 1)",
    conversationBackground: "rgba(18, 20, 22, 1)",
    conversationHeader: "rgba(23, 22, 26, 1)",
    sendBtn: "rgba(146, 139, 237, 1)",
    sendBtnBorder: "rgba(35, 40, 52, 1)",

    mediaBtnBackground: "rgba(31, 36, 48, 1)",
    mediaBtnBorder: "rgba(35, 40, 52, 1)",
    mediaBtnColor: "rgba(255,255,255,1)",
    messageInputTextColor: "rgba(255, 255, 255, 1)",
    messageInputBackground: "rgba(217, 217, 217, 0.05)",
    messageInputWrapperBackground: "rgba(23, 22, 26, 1)",
    dateSeparatorLine: "rgba(50, 49, 54, 1)",
    dateSeparatorColor: "rgba(245, 245, 245, 1)",
    translationMessageTextColor: "rgba(161, 159, 185, 1)",
    translationMessageTextColorReceived: "rgba(161, 159, 185, 1)",
    translationMessageBorderColor: "rgba(161, 159, 185, 0.15)",
    replyElementBgReceived: "#292A39",
    replyElementBgSent: "#5A54CC",

  },
  call: {
    callElementSelectedBackground: "rgba(41, 40, 66, 1)",
    callElementBackground: "rgba(29, 28, 33, 1)",
  },

  sidebar: {
    background: "rgba(23, 22, 26, 1)",
    iconColor: "rgba(142, 146, 154, 1)",
    selectedIconColor: "rgba(146, 139, 237, 1)",
    selectedBtnTextColor: "rgba(241, 241, 241, 1)",
    selectedBtnBackground: "rgba(35, 40, 52, 1)",
    avatarBorderColor: "rgba(142, 146, 154, 1)",
    borderColor: "rgba(50, 49, 54, 1)",
  },

  primaryButton: {
    background: "rgba(31, 36, 48, 1)",
    borderColor: "rgba(146, 139, 237, 1)",
    color: "rgba(146, 139, 237, 1)",
    removeBackground: "rgba(241, 124, 124,0.1)",
  },

  toggleButton: {
    borderColor: "rgba(146, 139, 237, 0.5)",
  },

  loginButton: {
    background: "rgba(31, 36, 48, 1)",
    borderColor: "rgba(75, 73, 115, 1)",
    color: "rgba(255, 255, 255, 1)",
  },

  callComponent: {
    participantsListBackground: "rgba(18, 20, 22, 1)",
    participantComponentBackground: "rgba(29, 31, 38, 1)",
    speakingBorder: "rgba(146, 139, 237, 1)",
    controlButtonTextColor: "rgba(193, 194, 203, 1)",

    controlButtonBackgroundActive: "rgba(250, 250, 250, 1)",
    controlButtonIconActive: "rgba(24, 29, 36, 1)",

    controlButtonBackgroundInactive: " rgba(24, 29, 36, 1)",
    controlButtonIconInactive: "rgba(250, 250, 250, 1)",
    translationModeBg: "rgba(41, 40, 66, 1)",
    translationModeButtonBt: "rgba(24, 29, 36, 1)",

    speakingLabelBg: "rgba(111, 105, 255, 0.6)"

  },
  meetingComponent: {
    meetingElementBackground: "rgba(31, 36, 48, 1)",
    ongoingMeetingElementBackground: "rgba(75, 73, 115, 1)",
    meetingJoinBackground: "rgba(61, 58, 99, 1)",
  },
  check: {
    background: "rgba(146, 139, 237, 1)",
    border: "rgba(91, 91, 93, 1)",
    checkSign: "#1D1C21",
  },
  unreadCounter: {
    color: "rgba(1, 1, 1, 1)",
  },
  finishSpeakBtn: {
    background: "rgba(255, 255, 255, 1)",
    color: "rgba(56, 55, 69, 1)",
  },
  listenerWrapper: {
    background: "rgba(31, 36, 48, 1)",
    color: "rgba(146, 139, 237, 1)",
  },
  moodIcon: {
    background: "rgba(31, 36, 48, 1)",
    backgroundSelected: "rgba(146, 139, 237, 1)",
    color: "rgba(150, 156, 161, 0.7)",
    colorSelected: "rgba(255, 255, 255, 1)",
  },
  planPicker: {
    selectorColor: "rgba(31, 36, 48, 1)",
    unCheckedColor: "#3D4250",
  },
  first_time_message: {
    background: "rgba(31, 33, 55, 1)",
  },

  premium_green: "rgba(23, 255, 158, 1)",
  valid_green: "rgba(112, 203, 151, 1)",
};
